const SERVER_URL_API = process.env.REACT_APP_BASE_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '58823385392-kdp78in4jnejh3nlnfc45vv55345joul.apps.googleusercontent.com';
export const FACEBOOK_CLIENT_ID = process.env.REACT_APP_FACEBOOK_CLIENT_ID || '199890537986100';

export default SERVER_URL_API;
